import React, {
  useReducer,
  useEffect,
  useRef,
  useState
} from 'react';

import {
  Button,
  IconButton,
  Avatar as Foto,
  makeStyles,
  Grid
} from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';

import { validate } from '../../../utils/validators';
import './Input.css';

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};

const useStyles = makeStyles((theme) => ({
  prod: {
    backgroundColor: theme.palette.background.dark,
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    margin: '0 auto'
  },
  button: {
    margin: '15px auto'
  },
  remover: {
    marginLeft: '15px'
  },
  grid: {
    textAlign: 'center',
    width: '100%',
    display: 'block'
  }
}));

const Avatar = (props) => {
  const classes = useStyles();
  const {
    id,
    label,
    name,
    extraClass,
    errorText,
    onInput,
    validators,
    initialValue,
    initialValid,
    InputLabelProps
  } = props;

  const [inputState, dispatch] = useReducer(inputReducer, {
    value: initialValue || '',
    isValid: initialValid || false,
    isTouched: initialValid || false
  });

  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const [previewUrl, setPreviewUrl] = useState();
  const filePickerRef = useRef();

  useEffect(() => {
    if (!value) {
      setPreviewUrl(false);
      return;
    }
    if (typeof value === 'string') {
      if (value.includes(process.env.REACT_APP_BACKEND_IMG)) {
        setPreviewUrl(value);
      }
    } else {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
      };
      fileReader.readAsDataURL(value);
    }
  }, [value]);

  const pickImageHandler = () => {
    filePickerRef.current.click();
  };

  const pickedHandler = (event) => {
    let pickedFile;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      console.log(pickedFile);
      dispatch({ type: 'CHANGE', val: pickedFile, validators });
    }
  };

  const removeImageHandler = () => {
    dispatch({ type: 'CHANGE', val: '', validators });
  };

  const touchHandler = (event) => {
    console.log(event);
    dispatch({ type: 'TOUCH' });
  };

  return (
    <div className="form-control">
      <input
        id={id}
        ref={filePickerRef}
        style={{ display: 'none' }}
        type="file"
        name={name}
        accept=".jpg,.png,.jpeg"
        onChange={pickedHandler}
        onTouchStart={touchHandler}
      />
      <div className={`image-upload ${extraClass && 'center'}`}>
        <p {...InputLabelProps}>{label}</p>
        <div className="image-upload__preview">
          {previewUrl ? <Foto alt="Remy Sharp" src={previewUrl} className={`${classes.large} ${extraClass}`} /> : <Foto alt="Remy Sharp" src="" className={`${classes.large} ${extraClass}`} />}
        </div>
        <Grid container alignContent="center" alignItems="center" justify="center" spacing={3}>
          <Grid item xs={12} className={classes.grid}>
            <Button className={classes.button} type="button" variant="contained" color="primary" size="small" onClick={pickImageHandler}>
              Selecionar Imagem
            </Button>
            {previewUrl && (
              <IconButton aria-label="delete" className={classes.remover} type="button" variant="contained" color="secondary" size="small" onClick={removeImageHandler}>
                <DeleteIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </div>
      {!isValid && <p>{errorText}</p>}
    </div>
  );
};
export default Avatar;
